import React from 'react'
import copy from "copy-to-clipboard";
import { BsFillCaretRightFill } from "react-icons/bs";
import { FaShareSquare } from "react-icons/fa";
import ThumbnailImage from '../../../assets/prince2.jpeg'
import { toast } from "react-hot-toast";

const CourseDetailsCard = () => {
   const handleShare = () => {
     copy(window.location.href);
     toast.success("Link copied to clipboard");
   };

  return (
    <>
      <div
        className={`flex flex-col gap-4 rounded-xl bg-richblue-5 bg-opacity-50  p-4 text-richblue-700`}
      >
        {/* Course Image */}
        <img
          src={ThumbnailImage}
          alt={"sre_foundation"}
          className="max-h-[300px] min-h-[180px] w-[400px] overflow-hidden rounded-2xl object-cover md:max-w-full"
        />
        <div className="px-4">
          <div className="space-x-3 pb-4 text-3xl font-semibold">
            Rs. {19999}
          </div>
          <div className="flex flex-col gap-4">
            <button className="yellowButton">Enroll Now</button>
            <button className="blackButton">Request Free Demo</button>
          </div>
          <div>
            <p className="pb-3 pt-6 text-center text-sm text-richblue-300">
              Contact Us
            </p>
          </div>

          <div className={``}>
            <p className={`my-2 text-xl font-semibold `}>Prerequisites :</p>
            <div className="flex flex-col gap-3 text-sm text-caribbeangreen-100">
              <p className={`flex gap-2`}>
                <BsFillCaretRightFill />
                <span>Familiarity with Basic IT terminologies.</span>
              </p>
              <p className={`flex gap-2`}>
                <BsFillCaretRightFill />
                <span>
                  Knowledge in IT software development.
                </span>
              </p>
            </div>
          </div>
          <div className="text-center">
            <button
              className="mx-auto flex items-center gap-2 py-6 text-richblue-400 "
              onClick={handleShare}
            >
              <FaShareSquare size={17} /> Share
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CourseDetailsCard